import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { Observable } from 'rxjs';
import { ApiResponseModel, ApiVisa } from '../../shared';
import { DgMktUnsubscribedContainerModel } from '../../../../../../models/aggregates/dgmkt/dgmkt-unsubscribed/dgmkt-unsubscribed-container.model';

@Injectable({
  providedIn: 'root',
})
export class DgMktUnsubscribedService extends BaseApiTemplateService<DgMktUnsubscribedContainerModel> {
  readonly url =
    Core2Config.TENANT_DOMAIN_URL_PREFIX +
    Core2Config.DGMKT_MODULE_PREFIX +
    'unsubscribe-numbers/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.DGMKT_MODULE_PREFIX +
      'unsubscribe-numbers/backoffice-ep';
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.DGMKT_MODULE_PREFIX +
      'unsubscribe-numbers/backoffice-ep';
    this.httpClient = http;
  }
}
